export const navigation = {
  projects: 'Renovationen',
  analysis: 'Analyse',
  propertyAnalysis: 'Gebäudeanalyse',
  craftsman: 'Handwerker',
  tools: 'Tools',
  createRealEstate: 'Immobilie erstellen',
  profile: 'Konto',
  profileSettings: 'Kontoeinstellungen',
  logoutFailed: 'Abmeldung fehlgeschlagen',
  realEstateOverview: 'Immobilienübersicht',
  create: 'Erstellen',
  project: 'Projekt',
  property: 'Immobilie',
  todo: 'To-do',
  appointment: 'Termine',
  component: 'Komponente',
  document: 'Unterlage',
  mortgage: 'Hypothek',
  invoice: 'Rechnung',
}
